"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JWT = void 0;
/* eslint-disable no-restricted-syntax */
const ethers_1 = require("ethers");
const base64url_1 = __importDefault(require("base64url"));
const JwtBase_1 = require("./JwtBase");
const { arrayify, keccak256 } = ethers_1.utils;
class JWT extends JwtBase_1.JwtBase {
    constructor(signer) {
        super();
        if (signer.privateKey) {
            this._signer = new ethers_1.Wallet(signer.privateKey);
        }
        else if (ethers_1.Signer.isSigner(signer)) {
            this._signer = signer;
        }
        else {
            throw new Error('Unsupported EIP191 signer');
        }
    }
    /**
     * Sign payload and return JWT
     *
     * @example
     * ```typescript
     * import { Keys } from '@ew-did-registry/keys';
     * import { JWT } from '@ew-did-registry/jwt';
     *
     * const keyPair = new Keys();
     * const jwt = new JWT(keyPair);
     * const payload = {claim: 'test'};
     * let token;
     *
     * try {
     *   token = await jwt.sign(payload, { algorithm: 'ES256' });
     *   console.log(token);
     * } catch(e) {
     *   console.log(e);
     * }
     * ```
     * @param {object} payload
     * @param {object} options
     * @returns {Promise<string>}
     */
    sign(payload, { issuer, subject, noTimestamp } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const header = {
                alg: 'ES256K',
                typ: 'JWT',
            };
            const encodedHeader = (0, base64url_1.default)(JSON.stringify(header));
            if (typeof payload === 'string') {
                payload = JSON.parse(payload);
            }
            payload = payload;
            if (issuer) {
                payload.iss = issuer;
            }
            if (subject) {
                payload.sub = subject;
            }
            if (!noTimestamp) {
                payload.iat = new Date().getTime();
            }
            const encodedPayload = (0, base64url_1.default)(JSON.stringify(payload));
            const msg = `0x${Buffer.from(`${encodedHeader}.${encodedPayload}`).toString('hex')}`;
            const signature = yield this._signer.signMessage(arrayify(keccak256(msg)));
            const encodedSignature = (0, base64url_1.default)(signature);
            return `${encodedHeader}.${encodedPayload}.${encodedSignature}`;
        });
    }
}
exports.JWT = JWT;
//# sourceMappingURL=JWTEIP191.js.map